import React from 'react';
import {
  BorderColor,
  DescriptionOutlined,
  Folder,
  CloseRounded,
  AddRounded,
  DeleteRounded,
  QuestionMarkRounded,
  PriorityHigh,
} from '@mui/icons-material';

const iconMap = {
  BorderColor,
  DescriptionOutlined,
  Folder,
  CloseRounded,
  AddRounded,
  DeleteRounded,
  QuestionMarkRounded,
  PriorityHigh,
};

const MuiIconUtil = ({ iconName, ...props }) => {
  const IconComponent = iconMap[iconName] || QuestionMarkRounded;
  return <IconComponent {...props} />;
};

export default MuiIconUtil;
